/*
 * @Author: taowuhua
 * @:
 * @Date: 2024-11-18 09:50:41
 * @LastEditors: taowuhua
 * @LastEditTime: 2024-12-01 14:43:25
 * @Description: file content
 */
export default [
  { label: "无祀孤魂", value: "无祀孤魂" },
  { label: "普利十方", value: "普利十方" },
  { label: "冤亲债主", value: "冤亲债主" },
  { label: "*氏门中历代宗亲", value: "*氏门中历代宗亲" },
  { label: "胎伤婴灵", value: "胎伤婴灵" },
  { label: "先曾祖父、先曾祖母", value: "先曾祖父、先曾祖母" },
  { label: "先曾伯父、先曾伯母", value: "先曾伯父、先曾伯母" },
  { label: "先曾叔父、先曾叔母", value: "先曾叔父、先曾叔母" },
  { label: "先外曾祖父、先外曾祖母", value: "先外曾祖父、先外曾祖母" },
  { label: "先外曾伯父、先外曾伯母", value: "先外曾伯父、先外曾伯母" },
  { label: "先外曾叔父、先外曾叔母", value: "先外曾叔父、先外曾叔母" },
  { label: "先祖父、先祖母", value: "先祖父、先祖母" },
  { label: "先伯祖父、先伯祖母", value: "先伯祖父、先伯祖母" },
  { label: "先叔祖父、先叔祖母", value: "先叔祖父、先叔祖母" },
  { label: "先外祖父、先外祖母", value: "先外祖父、先外祖母" },
  { label: "先外伯祖父、先外伯祖母", value: "先外伯祖父、先外伯祖母" },
  { label: "先外叔祖父、先外叔祖母", value: "先外叔祖父、先外叔祖母" },
  { label: "先父、先母", value: "先父、先母" },
  { label: "先养父、先养母", value: "先养父、先养母" },
  { label: "先继父、先继母", value: "先继父、先继母" },
  { label: "先伯父、先伯母", value: "先伯父、先伯母" },
  { label: "先叔父、先叔母", value: "先叔父、先叔母" },
  { label: "先姑父、先姑母", value: "先姑父、先姑母" },
  { label: "先岳父、先岳母", value: "先岳父、先岳母" },
  { label: "先岳伯父、先岳伯母", value: "先岳伯父、先岳伯母" },
  { label: "先岳叔父、先岳叔母", value: "先岳叔父、先岳叔母" },
  { label: "先舅父、先舅母", value: "先舅父、先舅母" },
  { label: "先姨父、先姨母", value: "先姨父、先姨母" },
  { label: "先翁、先姑", value: "先翁、先姑" },
  { label: "先夫、先妻", value: "先夫、先妻" },
  { label: "故兄、故嫂", value: "故兄、故嫂" },
  { label: "故姐、故姐夫", value: "故姐、故姐夫" },
  { label: "故弟、故弟媳", value: "故弟、故弟媳" },
  { label: "故妹、故妹夫", value: "故妹、故妹夫" },
  { label: "故堂兄、故堂嫂", value: "故堂兄、故堂嫂" },
  { label: "故堂姐、故堂姐夫", value: "故堂姐、故堂姐夫" },
  { label: "故堂弟、故堂弟媳", value: "故堂弟、故堂弟媳" },
  { label: "故堂妹、故堂妹夫", value: "故堂妹、故堂妹夫" },
  { label: "故表兄、故表嫂", value: "故表兄、故表嫂" },
  { label: "故表姐、故表姐夫", value: "故表姐、故表姐夫" },
  { label: "故表弟、故表弟媳", value: "故表弟、故表弟媳" },
  { label: "故表妹、故表妹夫", value: "故表妹、故表妹夫" },
  { label: "先辈、晚辈", value: "先辈、晚辈" },
  { label: "故好友、先恩师", value: "故好友、先恩师" },
  { label: "故爱子、故爱女", value: "故爱子、故爱女" },
]
